import { LuChevronRight } from "react-icons/lu";
import { colors, typography } from "../../../design/tokens";
import { RankedApp, StoreType } from "../../../model/rankings";
import { useAppDetailModal } from "../../../providers/AppDetailModalProvider";
import { AppIcon } from "./AppIcon";

interface AppStoreRankingItemProps {
  app: RankedApp;
  store: StoreType;
  country: string;
  lazy?: boolean;
}

export function AppStoreRankingItem({
  app,
  store,
  country,
  lazy = true,
}: AppStoreRankingItemProps) {
  const { open: openAppDetail } = useAppDetailModal();

  return (
    <button
      onClick={() => openAppDetail(store, app.id, country)}
      className="w-full flex items-center gap-3 p-3 rounded-lg transition-colors hover:bg-white/5 text-left group"
    >
      {/* Rank number */}
      <span
        className={`w-6 text-center ${typography.size.sm} ${colors.text.secondary}`}
      >
        {app.rank}.
      </span>

      {/* App icon */}
      <AppIcon
        src={app.icon}
        alt={app.name}
        size="small"
        lazy={lazy}
      />

      {/* App info */}
      <div className="flex-1 min-w-0">
        <h3
          className={`${typography.size.sm} ${typography.weight.medium} ${colors.text.primary} truncate`}
        >
          {app.name}
        </h3>
        <p className={`${typography.size.xs} ${colors.text.secondary} truncate`}>
          {app.developer}
        </p>
      </div>

      {/* Arrow indicator */}
      <LuChevronRight
        size={20}
        className={`${colors.text.secondary} flex-shrink-0 transition-opacity`}
      />
    </button>
  );
}
